(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  function openCartDrawer() {
    document.querySelector('.cart-drawer').classList.add('cart-drawer--active');
    document.body.style.overflow = 'hidden';
  }

  function closeCartDrawer() {
    document.querySelector('.cart-drawer').classList.remove('cart-drawer--active');
    document.body.style.overflow = '';
  }

  function updateCartItemCounts(count) {
    const cartCountElements = document.querySelectorAll('.cart-count');

    if (cartCountElements.length > 0) {
      // Update existing cart count badges
      cartCountElements.forEach((el) => {
        el.textContent = count;
      });

      // Remove badges if count is 0
      if (count === 0) {
        cartCountElements.forEach((el) => el.remove());
      }
    } else if (count > 0) {
      // Create cart count badge if it doesn't exist
      const cartButton = document.querySelector('.header__cart');
      if (cartButton) {
        const countSpan = document.createElement('span');
        countSpan.className = 'cart-count';
        countSpan.textContent = count;
        cartButton.insertBefore(countSpan, cartButton.querySelector('svg'));
      }
    }
  }

  async function updateCartDrawer() {
    try {
      const res = await fetch('/?section_id=cart-drawer');
      const text = await res.text();
      const html = document.createElement('div');
      html.innerHTML = text;

      const newBox = html.querySelector('.cart-drawer').innerHTML;
      document.querySelector('.cart-drawer').innerHTML = newBox;

      addCartDrawerListeners();
    } catch (error) {
      console.error('Failed to update cart drawer:', error);
    }
  }

  function addCartDrawerListeners() {
    // Remove item buttons
    document.querySelectorAll('.cart-drawer-item-remove').forEach((button) => {
      button.addEventListener('click', async (e) => {
        e.preventDefault();

        // Prevent multiple clicks
        if (button.disabled) return;

        // Get line item key
        const key = button.getAttribute('data-line-item-key');

        // Show loading state
        button.textContent = 'Suppression...';
        button.disabled = true;

        try {
          // Remove item by setting quantity to 0
          const res = await fetch('/cart/update.js', {
            method: 'POST',
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({ updates: { [key]: 0 } }),
          });

          if (!res.ok) throw new Error('Cart update failed');

          const cart = await res.json();
          updateCartItemCounts(cart.item_count);

          // Update cart drawer
          await updateCartDrawer();

          // Dispatch event for product page to update button state
          window.dispatchEvent(new CustomEvent('cartUpdated', {
            detail: { cart: cart }
          }));
        } catch (error) {
          console.error('Failed to remove item:', error);
          // Remove loading state on error
          button.textContent = 'Supprimer';
          button.disabled = false;
        }
      });
    });

    // Prevent closing when clicking inside the drawer
    document.querySelector('.cart-drawer-box')?.addEventListener('click', (e) => {
      e.stopPropagation();
    });

    // Close drawer listeners
    document.querySelectorAll('.cart-drawer-header-right-close').forEach((el) => {
      el.addEventListener('click', (e) => {
        e.preventDefault();
        closeCartDrawer();
      });
    });

    // Close when clicking on overlay
    document.querySelector('.cart-drawer')?.addEventListener('click', (e) => {
      if (e.target.classList.contains('cart-drawer')) {
        closeCartDrawer();
      }
    });

    // ESC key to close drawer
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && document.querySelector('.cart-drawer--active')) {
        closeCartDrawer();
      }
    });
  }

  // Initialize cart drawer listeners
  document.addEventListener('DOMContentLoaded', addCartDrawerListeners);

  // Handle add to cart forms
  document.addEventListener('submit', async (e) => {
    if (e.target.matches('form[action="/cart/add"]')) {
      e.preventDefault();

      try {
        // Submit form with ajax
        const res = await fetch('/cart/add', {
          method: 'POST',
          body: new FormData(e.target),
        });

        if (!res.ok) throw new Error('Add to cart failed');

        // Get cart count
        const cartRes = await fetch('/cart.js');
        const cart = await cartRes.json();
        updateCartItemCounts(cart.item_count);

        // Update cart drawer
        await updateCartDrawer();

        // Open cart drawer
        openCartDrawer();
      } catch (error) {
        console.error('Failed to add to cart:', error);
      }
    }
  });

  // Handle cart links
  document.addEventListener('click', (e) => {
    if (e.target.matches('a[href="/cart"]') || e.target.closest('a[href="/cart"]')) {
      e.preventDefault();
      openCartDrawer();
    }
  });

  // Expose functions globally for header integration
  window.openCartDrawer = openCartDrawer;
  window.closeCartDrawer = closeCartDrawer;
  window.updateCartDrawer = updateCartDrawer;
  window.updateCartItemCounts = updateCartItemCounts;

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    // Initialize mobile toggle function
    function initializeMobileToggle() {
      const filterToggle = document.querySelector('[data-action="toggle-mobile-filters"]');
      const mobileFilters = document.querySelector('[data-mobile-filters]');

      if (filterToggle && mobileFilters) {
        // Remove any existing listener by cloning the element
        const newToggle = filterToggle.cloneNode(true);
        filterToggle.parentNode.replaceChild(newToggle, filterToggle);

        newToggle.addEventListener('click', function() {
          const updatedMobileFilters = document.querySelector('[data-mobile-filters]');
          if (updatedMobileFilters) {
            updatedMobileFilters.classList.toggle('active');
            const isExpanded = updatedMobileFilters.classList.contains('active');
            newToggle.setAttribute('aria-expanded', isExpanded);
          }
        });
      }
    }

    // Initialize filter listeners function
    function initializeFilterListeners() {
      // Single filter selection logic
      const filterOptions = document.querySelectorAll('.collection-filter__option');
      filterOptions.forEach(option => {
        option.addEventListener('click', function(e) {
          e.preventDefault();

          // Get filter data from attributes
          const filterType = this.getAttribute('data-filter-type');
          const filterValue = this.getAttribute('data-filter-value');

          // Build clean URL with only this filter
          const baseUrl = window.location.pathname;
          const url = `${baseUrl}?${filterType}=${encodeURIComponent(filterValue)}`;

          // Update the collection via AJAX
          updateCollection(url);
        });
      });

      // Clear filters
      const clearButtons = document.querySelectorAll('[data-action="clear-filters"]');
      clearButtons.forEach(button => {
        button.addEventListener('click', function(e) {
          e.preventDefault();
          updateCollection(window.location.pathname);
        });
      });
    }

    // Initialize filter listeners on page load
    initializeFilterListeners();

    // Initialize mobile toggle on page load
    initializeMobileToggle();


    function updateCollection(url) {
      // Show loading state
      document.getElementById('collection-products').style.opacity = '0.5';

      // Parse URL to get section params
      const urlObj = new URL(url, window.location.origin);
      const sectionUrl = `${urlObj.pathname}?section_id=collection${urlObj.search ? '&' + urlObj.search.substring(1) : ''}`;

      fetch(sectionUrl)
        .then(response => response.text())
        .then(html => {
          // Update the products section
          const newContent = new DOMParser().parseFromString(html, 'text/html');
          const newProductsSection = newContent.getElementById('collection-products');
          const newFiltersSection = newContent.getElementById('collection-filters');

          if (newProductsSection) {
            document.getElementById('collection-products').innerHTML = newProductsSection.innerHTML;
          }

          // Update the filters section to show active states
          if (newFiltersSection) {
            document.getElementById('collection-filters').innerHTML = newFiltersSection.innerHTML;
          }

          // Update URL without reload
          window.history.pushState({}, '', url);

          // Re-initialize lazy loading for new content
          initializeCollectionLazyLoading();

          // Re-initialize infinite scroll for new content
          if (typeof window.reinitializeInfiniteScroll === 'function') {
            window.reinitializeInfiniteScroll();
          }

          // Re-initialize filter event listeners
          initializeFilterListeners();

          // Re-initialize mobile toggle
          initializeMobileToggle();

          // Hide loading state
          document.getElementById('collection-products').style.opacity = '1';

          // Close mobile menu if open
          const mobileFilters = document.querySelector('[data-mobile-filters]');
          const filterToggle = document.querySelector('[data-action="toggle-mobile-filters"]');
          if (mobileFilters) {
            mobileFilters.classList.remove('active');
            if (filterToggle) {
              filterToggle.setAttribute('aria-expanded', 'false');
            }
          }
        })
        .catch(error => {
          console.error('Error updating collection:', error);
          document.getElementById('collection-products').style.opacity = '1';
        });
    }

    // Infinite scroll state management
    let isLoading = false;
    let hasMoreProducts = true;
    let currentPage = 1;

    // Initialize infinite scroll functionality
    function initializeInfiniteScroll() {
      // Add class to body to hide traditional pagination
      document.body.classList.add('js-infinite-scroll');

      const loadingTrigger = document.getElementById('loading-trigger');
      if (!loadingTrigger) return;

      // Set up intersection observer for infinite scroll
      if ('IntersectionObserver' in window) {
        const scrollObserver = new IntersectionObserver((entries) => {
          entries.forEach(entry => {
            if (entry.isIntersecting && !isLoading && hasMoreProducts) {
              loadNextPage();
            }
          });
        }, {
          rootMargin: '100px 0px', // Trigger 100px before the element comes into view
          threshold: 0.1
        });

        scrollObserver.observe(loadingTrigger);
      }
    }

    // Load next page of products
    async function loadNextPage() {
      if (isLoading || !hasMoreProducts) return;

      isLoading = true;

      // Hide any existing error messages
      const existingErrorMessage = document.getElementById('error-message');
      if (existingErrorMessage) {
        existingErrorMessage.style.display = 'none';
      }

      const loadingTrigger = document.getElementById('loading-trigger');
      const loader = document.getElementById('infinite-loader');
      const nextUrl = loadingTrigger?.dataset.nextUrl;

      if (!nextUrl || !loadingTrigger) {
        hasMoreProducts = false;
        return;
      }

      // Show loading state
      if (loader) {
        loader.classList.add('loading');
      }

      let response = null;
      let sectionUrl = '';

      try {
        // Parse URL to get section params
        const urlObj = new URL(nextUrl, window.location.origin);
        sectionUrl = `${urlObj.pathname}?section_id=collection${urlObj.search ? '&' + urlObj.search.substring(1) : ''}`;

        response = await fetch(sectionUrl);
        if (!response.ok) throw new Error(`HTTP ${response.status}`);

        const html = await response.text();
        const newContent = new DOMParser().parseFromString(html, 'text/html');
        const newProductsGrid = newContent.querySelector('#products-grid');
        const newLoadingTrigger = newContent.querySelector('#loading-trigger');
        const productsInfo = newContent.querySelector('.collection-products__info');

        if (newProductsGrid && newProductsGrid.children.length > 0) {
          // Append new products to existing grid
          const currentGrid = document.getElementById('products-grid');
          Array.from(newProductsGrid.children).forEach(product => {
            currentGrid.appendChild(product);
          });

          // Update products count info
          if (productsInfo) {
            const currentInfo = document.querySelector('.collection-products__info');
            if (currentInfo) {
              currentInfo.innerHTML = productsInfo.innerHTML;
            }
          }

          // Update loading trigger with new next URL
          if (newLoadingTrigger && newLoadingTrigger.dataset.nextUrl) {
            loadingTrigger.dataset.nextUrl = newLoadingTrigger.dataset.nextUrl;
            currentPage++;

            // Update URL for SEO
            updatePageURL(urlObj.pathname, urlObj.search, currentPage);
          } else {
            // No more pages
            hasMoreProducts = false;
            loadingTrigger.style.display = 'none';
          }

          // Re-initialize lazy loading and wishlist for new products
          initializeCollectionLazyLoading();

          // Re-initialize wishlist for new products (check if function exists)
          if (typeof initializeWishlistButtons === 'function') {
            initializeWishlistButtons();
          }

        } else {
          // No more products
          hasMoreProducts = false;
          loadingTrigger.style.display = 'none';
        }

      } catch (error) {
        console.error('Error loading more products:', error);
        console.error('Failed URL:', sectionUrl);
        console.error('Response status:', response?.status || 'No response');
        showErrorMessage();
      } finally {
        isLoading = false;
        if (loader) {
          loader.classList.remove('loading');
        }
      }
    }

    // Show end of results message
    function showEndMessage() {
      let endMessage = document.getElementById('end-message');
      if (!endMessage) {
        // Create end message if it doesn't exist
        endMessage = document.createElement('div');
        endMessage.id = 'end-message';
        endMessage.className = 'collection-products__end';
        endMessage.innerHTML = '<p>You\'ve seen all products</p>';
        document.getElementById('collection-products').appendChild(endMessage);
      }
      endMessage.style.display = 'block';
    }

    // Show error message
    function showErrorMessage() {
      let errorMessage = document.getElementById('error-message');
      if (!errorMessage) {
        errorMessage = document.createElement('div');
        errorMessage.id = 'error-message';
        errorMessage.className = 'collection-products__end';
        errorMessage.innerHTML = '<p>Error loading products. Please try refreshing the page.</p>';
        document.getElementById('collection-products').appendChild(errorMessage);
      }
      errorMessage.style.display = 'block';
    }

    // Update URL for SEO and browser history
    function updatePageURL(pathname, search, page) {
      if ('history' in window && 'pushState' in window.history) {
        const url = new URL(window.location);
        url.pathname = pathname;
        if (search) {
          // Parse existing search params
          const searchParams = new URLSearchParams(search);
          searchParams.forEach((value, key) => {
            if (key !== 'page') {
              url.searchParams.set(key, value);
            }
          });
        }
        url.searchParams.set('page', page.toString());
        window.history.replaceState({}, '', url.toString());
      }
    }

    // Enhanced lazy loading with Intersection Observer
    function initializeCollectionLazyLoading() {
      if ('IntersectionObserver' in window) {
        const productCards = document.querySelectorAll('.product-card-link');
        const imageObserver = new IntersectionObserver((entries, observer) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              const productCard = entry.target;
              const images = productCard.querySelectorAll('img[loading="lazy"]');

              images.forEach(img => {
                // Force load the image
                if (img.dataset.src) {
                  img.src = img.dataset.src;
                  img.removeAttribute('data-src');
                }

                // Remove loading attribute to trigger immediate load
                img.removeAttribute('loading');
              });

              observer.unobserve(productCard);
            }
          });
        }, {
          rootMargin: '50px 0px',
          threshold: 0.1
        });

        productCards.forEach(card => {
          imageObserver.observe(card);
        });
      }
    }

    // Initialize lazy loading on page load
    initializeCollectionLazyLoading();

    // Initialize infinite scroll
    initializeInfiniteScroll();

    // Re-initialize infinite scroll after filter updates
    function reinitializeInfiniteScroll() {
      // Reset infinite scroll state
      isLoading = false;
      hasMoreProducts = true;
      currentPage = 1;

      // Hide any existing end/error messages
      const endMessage = document.getElementById('end-message');
      const errorMessage = document.getElementById('error-message');
      if (endMessage) endMessage.style.display = 'none';
      if (errorMessage) errorMessage.style.display = 'none';

      // Re-initialize if loading trigger exists
      const loadingTrigger = document.getElementById('loading-trigger');
      if (loadingTrigger) {
        initializeInfiniteScroll();
      }
    }

    // Make reinitializeInfiniteScroll available globally for the updateCollection function
    window.reinitializeInfiniteScroll = reinitializeInfiniteScroll;
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const faqToggles = document.querySelectorAll('[data-faq-toggle]');
    
    faqToggles.forEach(toggle => {
      toggle.addEventListener('click', function() {
        const isExpanded = this.getAttribute('aria-expanded') === 'true';
        const content = this.parentNode.querySelector('[data-faq-content]');
        
        // Close all other FAQ items
        faqToggles.forEach(otherToggle => {
          if (otherToggle !== this) {
            otherToggle.setAttribute('aria-expanded', 'false');
            const otherContent = otherToggle.parentNode.querySelector('[data-faq-content]');
            otherContent.setAttribute('aria-hidden', 'true');
          }
        });
        
        // Toggle current FAQ item
        if (isExpanded) {
          this.setAttribute('aria-expanded', 'false');
          content.setAttribute('aria-hidden', 'true');
        } else {
          this.setAttribute('aria-expanded', 'true');
          content.setAttribute('aria-hidden', 'false');
        }
      });
      
      // Keyboard support
      toggle.addEventListener('keydown', function(e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          this.click();
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    // Header scroll functionality
    const header = document.querySelector('.header');
    let lastScrollTop = 0;
    let ticking = false;

    function handleScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (scrollTop > 50) {
        header.classList.add('scrolled');
        document.body.classList.add('header-scrolled');
      } else {
        header.classList.remove('scrolled');
        document.body.classList.remove('header-scrolled');
      }

      lastScrollTop = scrollTop;
      ticking = false;
    }

    window.addEventListener('scroll', function() {
      if (!ticking) {
        requestAnimationFrame(handleScroll);
        ticking = true;
      }
    });

    // Menu functionality - Sidebar drawer for both desktop and mobile
    const hamburgerButton = document.querySelector('[data-action="toggle-menu"]');
    const sidebarDrawer = document.querySelector('[data-sidebar-drawer]');
    const sidebarOverlay = document.querySelector('[data-sidebar-overlay]');

    function closeSidebar() {
      if (sidebarDrawer) {
        sidebarDrawer.classList.remove('active');
      }
      if (sidebarOverlay) {
        sidebarOverlay.classList.remove('active');
      }
      if (hamburgerButton) {
        hamburgerButton.setAttribute('aria-expanded', 'false');
      }
    }

    // Toggle sidebar drawer on hamburger button click
    if (hamburgerButton) {
      hamburgerButton.addEventListener('click', function(event) {
        event.stopPropagation();

        if (sidebarDrawer && sidebarOverlay) {
          sidebarDrawer.classList.toggle('active');
          sidebarOverlay.classList.toggle('active');
          const isExpanded = sidebarDrawer.classList.contains('active');
          hamburgerButton.setAttribute('aria-expanded', isExpanded);
        }
      });
    }

    // Close sidebar when clicking overlay
    if (sidebarOverlay) {
      sidebarOverlay.addEventListener('click', closeSidebar);
    }

    // Close sidebar when clicking close button
    const sidebarCloseButton = document.querySelector('[data-action="close-sidebar"]');
    if (sidebarCloseButton) {
      sidebarCloseButton.addEventListener('click', closeSidebar);
    }

    // Close sidebar when clicking outside
    document.addEventListener('click', function(event) {
      if (sidebarDrawer && !sidebarDrawer.contains(event.target) && !hamburgerButton.contains(event.target)) {
        closeSidebar();
      }
    });

    // Close sidebar on window resize
    window.addEventListener('resize', closeSidebar);

    // Close sidebar on ESC key
    document.addEventListener('keydown', function(event) {
      if (event.key === 'Escape') {
        closeSidebar();
      }
    });

    // Cart drawer functionality
    const cartButton = document.querySelector('[data-action="open-cart-drawer"]');
    if (cartButton) {
      cartButton.addEventListener('click', function() {
        if (window.openCartDrawer) {
          window.openCartDrawer();
        }
      });
    }

    // Wishlist count functionality
    function updateWishlistCount() {
      const wishlistCountEl = document.querySelector('.wishlist-count');
      if (!wishlistCountEl) return;

      try {
        // Get wishlist from localStorage
        const wishlistKey = 'marie_laporte_wishlist';
        const wishlist = localStorage.getItem(wishlistKey);
        const wishlistArray = wishlist ? JSON.parse(wishlist) : [];
        const count = wishlistArray.length;

        // Update count display
        if (count > 0) {
          wishlistCountEl.textContent = count;
          wishlistCountEl.style.display = 'flex';
        } else {
          wishlistCountEl.style.display = 'none';
        }
      } catch (error) {
        console.error('Error updating wishlist count:', error);
      }
    }

    // Initialize wishlist count on page load
    updateWishlistCount();

    // Listen for wishlist updates
    window.addEventListener('wishlistUpdated', updateWishlistCount);

    // Listen for storage events (when wishlist changes in another tab)
    window.addEventListener('storage', function(e) {
      if (e.key === 'marie_laporte_wishlist') {
        updateWishlistCount();
      }
    });

  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  // Helper function to check if a variant is already in the cart
  async function isVariantInCart(variantId) {
    try {
      const response = await fetch('/cart.js');
      if (!response.ok) {
        console.error('Error fetching cart:', response.statusText);
        return false;
      }
      const cart = await response.json();
      return cart.items.some(item => item.id === parseInt(variantId));
    } catch (error) {
      console.error('Error checking cart:', error);
      return false;
    }
  }

  // Function to update the add to cart button state based on cart contents
  async function updateAddToCartButtonState(variantId, button) {
    if (!button || !variantId) return;

    const inCart = await isVariantInCart(variantId);

    if (inCart) {
      button.disabled = true;
      button.classList.add('product-page__add-to-cart--in-cart');
      const originalText = button.getAttribute('data-original-text') || button.textContent;
      if (!button.hasAttribute('data-original-text')) {
        button.setAttribute('data-original-text', originalText);
      }
      const inCartText = button.getAttribute('data-in-cart-text') || 'Already in Cart';
      button.textContent = inCartText;
    } else {
      button.disabled = false;
      button.classList.remove('product-page__add-to-cart--in-cart');
      const originalText = button.getAttribute('data-original-text');
      if (originalText) {
        button.textContent = originalText;
      }
    }
  }

  function initProductSlideshow(slideshow) {
    const slides = slideshow.querySelectorAll('.product-page-slideshow__slide');
    const dots = slideshow.querySelectorAll('.product-page-slideshow__dot');
    const prevArrow = slideshow.querySelector('.product-page-slideshow__arrow--prev');
    const nextArrow = slideshow.querySelector('.product-page-slideshow__arrow--next');
    let currentSlide = 0;

    if (slides.length <= 1) return;
    
    function showSlide(index) {
      slides.forEach(slide => slide.classList.remove('product-page-slideshow__slide--active'));
      dots.forEach(dot => dot.classList.remove('product-page-slideshow__dot--active'));

      slides[index].classList.add('product-page-slideshow__slide--active');
      if (dots[index]) {
        dots[index].classList.add('product-page-slideshow__dot--active');
      }
    }
    
    function nextSlide() {
      currentSlide = (currentSlide + 1) % slides.length;
      showSlide(currentSlide);
    }
    
    function prevSlide() {
      currentSlide = (currentSlide - 1 + slides.length) % slides.length;
      showSlide(currentSlide);
    }
    
    function handleArrowClick(e, direction) {
      e.preventDefault();
      e.stopPropagation();
      direction === 'next' ? nextSlide() : prevSlide();
    }
    
    function handleKeydown(e) {
      if (e.key === 'ArrowLeft' || e.key === 'ArrowRight') {
        e.preventDefault();
        e.key === 'ArrowLeft' ? prevSlide() : nextSlide();
      }
    }
    
    // Event listeners
    if (nextArrow) {
      nextArrow.addEventListener('click', (e) => handleArrowClick(e, 'next'));
    }
    
    if (prevArrow) {
      prevArrow.addEventListener('click', (e) => handleArrowClick(e, 'prev'));
    }
    
    slideshow.addEventListener('keydown', handleKeydown);
    
    // Accessibility setup
    slideshow.setAttribute('tabindex', '0');
    slideshow.setAttribute('role', 'region');
    slideshow.setAttribute('aria-label', "{{ 'product.image_gallery' | t }}");
  }

  function initProductTabs() {
    const tabButtons = document.querySelectorAll('.product-page__tab-button');
    const tabPanels = document.querySelectorAll('.product-page__tab-panel');

    function activateTab(button) {
      const targetId = button.getAttribute('data-tab-target');
      
      // Remove active class from all buttons and panels
      tabButtons.forEach(btn => btn.classList.remove('product-page__tab-button--active'));
      tabPanels.forEach(panel => panel.classList.remove('product-page__tab-panel--active'));
      
      // Add active class to clicked button and corresponding panel
      button.classList.add('product-page__tab-button--active');
      const targetPanel = document.getElementById(targetId);
      if (targetPanel) {
        targetPanel.classList.add('product-page__tab-panel--active');
      }
    }

    tabButtons.forEach(button => {
      button.addEventListener('click', () => activateTab(button));
    });
  }

  function initVariantSelection() {
    const productForm = document.querySelector('form[action*=\"/cart/add\"]');
    if (!productForm) return;

    const variantIdInput = document.getElementById('product-variant-id');
    if (!variantIdInput) return;

    // Get product data from the form
    const productId = document.querySelector('.product-page-slideshow')?.dataset.productId;
    if (!productId) return;

    // Fetch product JSON to get variant data
    fetch(`/products/${window.location.pathname.split('/').pop()}.js`)
      .then(response => response.json())
      .then(product => {
        const optionInputs = productForm.querySelectorAll('.product-page__option-input');

        function updateVariant() {
          // Get selected options
          const selectedOptions = {};
          optionInputs.forEach(input => {
            if (input.checked) {
              const position = input.dataset.optionPosition;
              selectedOptions[position] = input.value;
            }
          });

          // Find matching variant
          const matchingVariant = product.variants.find(variant => {
            return variant.options.every((option, index) => {
              return option === selectedOptions[(index + 1).toString()];
            });
          });

          if (matchingVariant) {
            variantIdInput.value = matchingVariant.id;

            // Update price display
            const priceElement = document.getElementById('product-price');
            if (priceElement && matchingVariant.price) {
              const amount = (matchingVariant.price / 100).toFixed(0);
              const formattedPrice = `${amount}€`;
              priceElement.textContent = formattedPrice;
            }

            // Update button availability states
            updateOptionAvailability(product, selectedOptions);

            // Check if new variant is in cart and update button state
            const addToCartButton = productForm.querySelector('.product-page__add-to-cart');
            if (addToCartButton && addToCartButton.type === 'submit') {
              updateAddToCartButtonState(matchingVariant.id, addToCartButton);
            }
          }
        }

        function updateOptionAvailability(product, selectedOptions) {
          // For each option position, check which values are available
          const optionPositions = Object.keys(selectedOptions);

          optionPositions.forEach(position => {
            const inputs = productForm.querySelectorAll(`.product-page__option-input[data-option-position="${position}"]`);

            inputs.forEach(input => {
              const testOptions = { ...selectedOptions };
              testOptions[position] = input.value;

              // Check if any variant exists with these options
              const hasAvailableVariant = product.variants.some(variant => {
                const matches = Object.keys(testOptions).every(pos => {
                  return variant.options[parseInt(pos) - 1] === testOptions[pos];
                });
                return matches && variant.available;
              });

              const button = input.nextElementSibling;
              if (hasAvailableVariant) {
                input.disabled = false;
                button.style.opacity = '';
                button.style.cursor = '';
              } else {
                input.disabled = true;
                button.style.opacity = '0.3';
                button.style.cursor = 'not-allowed';
              }
            });
          });
        }

        // Listen for option changes
        optionInputs.forEach(input => {
          input.addEventListener('change', updateVariant);
        });

        // Initialize availability on load
        const initialOptions = {};
        optionInputs.forEach(input => {
          if (input.checked) {
            initialOptions[input.dataset.optionPosition] = input.value;
          }
        });
        updateOptionAvailability(product, initialOptions);
      })
      .catch(error => {
        console.error('Error loading product data:', error);
      });
  }

  document.addEventListener('DOMContentLoaded', function() {
    console.log('Product JavaScript loaded');
    const slideshow = document.querySelector('.product-page-slideshow');

    if (slideshow) {
      initProductSlideshow(slideshow);
    }

    initProductTabs();
    initVariantSelection();

    // Check initial variant status in cart
    const addToCartButton = document.querySelector('.product-page__add-to-cart');
    if (addToCartButton && addToCartButton.type === 'submit') {
      const variantIdInput = document.getElementById('product-variant-id') ||
                             document.querySelector('input[name="id"]');
      if (variantIdInput) {
        updateAddToCartButtonState(variantIdInput.value, addToCartButton);
      }
    }

    // Listen for cart updates (when items are removed from cart drawer)
    window.addEventListener('cartUpdated', function() {
      const addToCartBtn = document.querySelector('.product-page__add-to-cart');
      if (addToCartBtn && addToCartBtn.type === 'submit') {
        const variantInput = document.getElementById('product-variant-id') ||
                            document.querySelector('input[name="id"]');
        if (variantInput) {
          updateAddToCartButtonState(variantInput.value, addToCartBtn);
        }
      }
    });

    // Add to cart functionality
    const productForm = document.querySelector('form[action*="/cart/add"]');
    if (productForm) {
      productForm.addEventListener('submit', async function(e) {
        e.preventDefault();
        e.stopImmediatePropagation(); // Prevent cart-drawer.liquid global handler from also adding the item

        const formData = new FormData(productForm);
        const variantId = formData.get('id');
        const quantity = formData.get('quantity') || 1;
        const submitButton = productForm.querySelector('.product-page__add-to-cart');
        
        console.log('Adding to cart:', { variantId, quantity });
        
        // Show loading state
        if (submitButton) {
          submitButton.classList.add('loading');
          submitButton.disabled = true;
        }
        
        try {
          const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              id: variantId,
              quantity: parseInt(quantity)
            })
          });
          
          if (response.ok) {
            const item = await response.json();
            console.log('Item added to cart:', item);

            // Remove loading state on success
            if (submitButton) {
              submitButton.classList.remove('loading');
              submitButton.disabled = false;
            }

            // Get updated cart data and open drawer
            const cartResponse = await fetch('/cart.js');
            if (cartResponse.ok) {
              const cart = await cartResponse.json();

              // Update cart count in header
              window.updateCartItemCounts(cart.item_count);

              // Update cart drawer and open it
              await window.updateCartDrawer();
              window.openCartDrawer();

              // Update button state now that item is in cart
              updateAddToCartButtonState(variantId, submitButton);
            }
          } else {
            // Remove loading state on error
            if (submitButton) {
              submitButton.classList.remove('loading');
              submitButton.disabled = false;
            }
            
            const errorData = await response.json();
            console.error('Error adding to cart:', errorData);
            alert(errorData.message || 'Error adding item to cart');
          }
        } catch (error) {
          // Remove loading state on network error
          if (submitButton) {
            submitButton.classList.remove('loading');
            submitButton.disabled = false;
          }
          
          console.error('Network error:', error);
          alert('Network error. Please try again.');
        }
      });
    }
    
    // Helper function to refresh cart drawer
    async function refreshCartDrawer() {
      try {
        // Get updated drawer HTML from the section
        const response = await fetch('/?section_id=cart-drawer');
        if (response.ok) {
          const html = await response.text();
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');
          const newDrawerBody = doc.querySelector('.cart-drawer__body');
          
          const cartDrawer = document.getElementById('cart-drawer');
          if (newDrawerBody && cartDrawer) {
            const currentDrawerBody = cartDrawer.querySelector('.cart-drawer__body');
            if (currentDrawerBody) {
              currentDrawerBody.innerHTML = newDrawerBody.innerHTML;
              console.log('Cart drawer content refreshed');
            }
          }
        }
      } catch (error) {
        console.error('Error refreshing cart drawer:', error);
      }
    }

    // Initialize WishlistManager if not exists
    if (typeof window.WishlistManager === 'undefined') {
      window.WishlistManager = {
        key: 'marie_laporte_wishlist',

        get() {
          try {
            const wishlist = localStorage.getItem(this.key);
            return wishlist ? JSON.parse(wishlist) : [];
          } catch (error) {
            console.error('Error getting wishlist:', error);
            return [];
          }
        },

        save(wishlist) {
          try {
            localStorage.setItem(this.key, JSON.stringify(wishlist));

            // Dispatch event to update wishlist count in header
            window.dispatchEvent(new CustomEvent('wishlistUpdated', {
              detail: { count: wishlist.length }
            }));

            return true;
          } catch (error) {
            console.error('Error saving wishlist:', error);
            return false;
          }
        },

        add(product) {
          const wishlist = this.get();
          const exists = wishlist.find(item => item.id === product.id);
          if (!exists) {
            wishlist.push({
              id: product.id,
              title: product.title,
              url: product.url,
              price: product.price,
              image: product.image,
              handle: product.handle,
              addedAt: new Date().toISOString()
            });
            this.save(wishlist);
          }
          return !exists;
        },

        remove(productId) {
          const wishlist = this.get();
          const newWishlist = wishlist.filter(item => item.id !== productId);
          this.save(newWishlist);
          return wishlist.length !== newWishlist.length;
        },

        contains(productId) {
          return this.get().some(item => item.id === productId);
        },

        count() {
          return this.get().length;
        },

        updateWishlistIcon(button, isInWishlist) {
          const svg = button.querySelector('svg path');
          if (svg) {
            if (isInWishlist) {
              svg.setAttribute('fill', 'currentColor');
              button.setAttribute('aria-label', 'Remove from wishlist');
            } else {
              svg.setAttribute('fill', 'none');
              button.setAttribute('aria-label', 'Add to wishlist');
            }
          }
        }
      };
    }

    // Initialize product page wishlist button
    const productPageWishlistButton = document.querySelector('.product-page__wishlist');
    if (productPageWishlistButton) {
      const productId = parseInt(productPageWishlistButton.dataset.productId);

      // Set initial state
      if (productId) {
        const isInWishlist = window.WishlistManager.contains(productId);
        window.WishlistManager.updateWishlistIcon(productPageWishlistButton, isInWishlist);
      }

      // Add click handler
      productPageWishlistButton.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();

        const productId = parseInt(this.dataset.productId);
        if (!productId) return;

        // Get product data from the page
        const productTitle = document.querySelector('.product-page__title');
        const productPrice = document.querySelector('.product-page__price');
        const productImage = document.querySelector('.product-page-slideshow__slide img');

        const product = {
          id: productId,
          title: productTitle ? productTitle.textContent.trim() : '',
          url: window.location.pathname,
          price: productPrice ? productPrice.textContent.trim() : '',
          image: productImage ? productImage.getAttribute('src') : '',
          handle: window.location.pathname.split('/').pop()
        };

        const isInWishlist = window.WishlistManager.contains(productId);

        if (isInWishlist) {
          window.WishlistManager.remove(productId);
        } else {
          window.WishlistManager.add(product);
        }

        // Update icon immediately
        window.WishlistManager.updateWishlistIcon(this, !isInWishlist);
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slideshow-with-content"] && !Shopify.designMode) return;
  try {
    
  class Slideshow {
    constructor(element) {
      this.slideshow = element;
      this.slides = Array.from(this.slideshow.querySelectorAll('[data-slide-index]'));
      this.dots = Array.from(this.slideshow.querySelectorAll('[data-slideshow-dot]'));
      this.prevButton = this.slideshow.querySelector('[data-slideshow-prev]');
      this.nextButton = this.slideshow.querySelector('[data-slideshow-next]');
      this.currentIndex = 0;
      this.autoplay = this.slideshow.dataset.autoplay === 'true';
      this.autoplaySpeed = parseInt(this.slideshow.dataset.autoplaySpeed) || 5000;
      this.autoplayInterval = null;

      if (this.slides.length <= 1) return;

      this.init();
    }

    init() {
      // Bind event listeners
      if (this.prevButton) {
        this.prevButton.addEventListener('click', () => this.prev());
      }
      if (this.nextButton) {
        this.nextButton.addEventListener('click', () => this.next());
      }

      this.dots.forEach((dot, index) => {
        dot.addEventListener('click', () => this.goToSlide(index));
      });

      // Start autoplay if enabled
      if (this.autoplay) {
        this.startAutoplay();

        // Pause on hover
        this.slideshow.addEventListener('mouseenter', () => this.stopAutoplay());
        this.slideshow.addEventListener('mouseleave', () => this.startAutoplay());
      }

      // Keyboard navigation
      document.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowLeft') this.prev();
        if (e.key === 'ArrowRight') this.next();
      });

      // Touch/swipe support
      let touchStartX = 0;
      let touchEndX = 0;

      this.slideshow.addEventListener('touchstart', (e) => {
        touchStartX = e.changedTouches[0].screenX;
      }, { passive: true });

      this.slideshow.addEventListener('touchend', (e) => {
        touchEndX = e.changedTouches[0].screenX;
        this.handleSwipe();
      }, { passive: true });

      const handleSwipe = () => {
        const swipeThreshold = 50;
        const diff = touchStartX - touchEndX;

        if (Math.abs(diff) > swipeThreshold) {
          if (diff > 0) {
            this.next();
          } else {
            this.prev();
          }
        }
      };

      this.handleSwipe = handleSwipe;
    }

    goToSlide(index) {
      // Remove active class from current slide and dot
      this.slides[this.currentIndex].classList.remove('slideshow-with-content__slide--active');
      if (this.dots[this.currentIndex]) {
        this.dots[this.currentIndex].classList.remove('slideshow-with-content__dot--active');
        this.dots[this.currentIndex].setAttribute('aria-selected', 'false');
      }

      // Update index
      this.currentIndex = index;

      // Add active class to new slide and dot
      this.slides[this.currentIndex].classList.add('slideshow-with-content__slide--active');
      if (this.dots[this.currentIndex]) {
        this.dots[this.currentIndex].classList.add('slideshow-with-content__dot--active');
        this.dots[this.currentIndex].setAttribute('aria-selected', 'true');
      }

      // Reset autoplay timer
      if (this.autoplay) {
        this.stopAutoplay();
        this.startAutoplay();
      }
    }

    next() {
      const nextIndex = (this.currentIndex + 1) % this.slides.length;
      this.goToSlide(nextIndex);
    }

    prev() {
      const prevIndex = (this.currentIndex - 1 + this.slides.length) % this.slides.length;
      this.goToSlide(prevIndex);
    }

    startAutoplay() {
      if (!this.autoplay) return;
      this.autoplayInterval = setInterval(() => this.next(), this.autoplaySpeed);
    }

    stopAutoplay() {
      if (this.autoplayInterval) {
        clearInterval(this.autoplayInterval);
        this.autoplayInterval = null;
      }
    }
  }

  // Initialize all slideshows on page
  document.addEventListener('DOMContentLoaded', () => {
    const slideshows = document.querySelectorAll('[data-slideshow]');
    slideshows.forEach(slideshow => new Slideshow(slideshow));
  });

  // Reinitialize on Shopify section load (for theme editor)
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', (event) => {
      const slideshow = event.target.querySelector('[data-slideshow]');
      if (slideshow) {
        new Slideshow(slideshow);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wishlist"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    // Wishlist management utilities
    const WishlistManager = {
      key: 'marie_laporte_wishlist',
      _saving: false,
      
      get() {
        try {
          const wishlist = localStorage.getItem(this.key);
          return wishlist ? JSON.parse(wishlist) : [];
        } catch (error) {
          console.error('Error getting wishlist:', error);
          return [];
        }
      },
      
      async save(wishlist) {
        // Prevent concurrent saves
        if (this._saving) {
          await new Promise(resolve => setTimeout(resolve, 50));
          return this.save(wishlist);
        }

        this._saving = true;
        try {
          localStorage.setItem(this.key, JSON.stringify(wishlist));
          this.updateWishlistIcons();

          // Dispatch event to update wishlist count in header
          window.dispatchEvent(new CustomEvent('wishlistUpdated', {
            detail: { count: wishlist.length }
          }));

          return true;
        } catch (error) {
          console.error('Error saving wishlist:', error);
          return false;
        } finally {
          this._saving = false;
        }
      },
      
      async add(product) {
        const wishlist = this.get();
        const exists = wishlist.find(item => item.id === product.id);
        if (!exists) {
          wishlist.push({
            id: product.id,
            title: product.title,
            url: product.url,
            price: product.price,
            image: product.image,
            addedAt: new Date().toISOString()
          });
          await this.save(wishlist);
        }
        return !exists;
      },
      
      async remove(productId) {
        const wishlist = this.get();
        const newWishlist = wishlist.filter(item => item.id !== productId);
        await this.save(newWishlist);
        return wishlist.length !== newWishlist.length;
      },
      
      contains(productId) {
        return this.get().some(item => item.id === productId);
      },
      
      count() {
        return this.get().length;
      },
      
      clear() {
        localStorage.removeItem(this.key);
        this.updateWishlistIcons();
      },

      updateWishlistIcons() {
        // Update all wishlist icons on the page
        const wishlistButtons = document.querySelectorAll('.product-card__wishlist');
        wishlistButtons.forEach(button => {
          const productId = parseInt(button.closest('[data-product-id]')?.dataset.productId);
          if (productId) {
            this.updateWishlistIcon(button, this.contains(productId));
          }
        });
      },

      updateWishlistIcon(button, isInWishlist) {
        const svg = button.querySelector('svg path');
        if (svg) {
          if (isInWishlist) {
            svg.setAttribute('fill', 'currentColor');
            button.classList.add('product-card__wishlist--active');
            button.setAttribute('aria-label', 'Remove from wishlist');
          } else {
            svg.setAttribute('fill', 'none');
            button.classList.remove('product-card__wishlist--active');
            button.setAttribute('aria-label', 'Add to wishlist');
          }
        }
      }
    };

    // Make WishlistManager globally available
    window.WishlistManager = WishlistManager;

    // Load and display wishlist products if we're on the wishlist page
    if (document.getElementById('wishlist-content')) {
      loadWishlistProducts();
    }

    async function loadWishlistProducts() {
      const loadingEl = document.getElementById('wishlist-loading');
      const emptyEl = document.getElementById('wishlist-empty');
      const productsEl = document.getElementById('collection-products');
      const gridEl = document.getElementById('wishlist-products-grid');
      const countEl = document.getElementById('wishlist-count');

      const wishlist = WishlistManager.get();
      
      // Show empty state if no products
      if (wishlist.length === 0) {
        loadingEl.style.display = 'none';
        emptyEl.style.display = 'block';
        return;
      }

      try {
        // Fetch product data from Shopify with better error handling
        const productPromises = wishlist.map(async (item) => {
          try {
            const handle = item.url.split('/').pop();
            const response = await fetch(`/products/${handle}.js`);
            if (response.ok) {
              const product = await response.json();
              return { success: true, product, originalItem: item };
            } else {
              console.warn(`Product not found: ${handle}`);
              return { success: false, originalItem: item };
            }
          } catch (error) {
            console.error('Error fetching product:', error);
            return { success: false, originalItem: item };
          }
        });

        const results = await Promise.all(productPromises);
        const products = results.filter(r => r.success).map(r => r.product);
        const failedItems = results.filter(r => !r.success).map(r => r.originalItem);
        
        // Remove failed products from wishlist
        if (failedItems.length > 0) {
          console.log(`Removing ${failedItems.length} unavailable products from wishlist`);
          const validWishlist = wishlist.filter(item => 
            !failedItems.some(failed => failed.id === item.id)
          );
          WishlistManager.save(validWishlist);
        }

        if (products.length === 0) {
          loadingEl.style.display = 'none';
          emptyEl.style.display = 'block';
          return;
        }

        // Generate product cards HTML - batch render for better performance
        gridEl.innerHTML = '';
        
        const cardPromises = products.map(product => generateProductCard(product));
        const cardHtmlArray = await Promise.all(cardPromises);
        
        // Filter out null/undefined cards and join them
        const validCards = cardHtmlArray.filter(Boolean);
        if (validCards.length > 0) {
          gridEl.innerHTML = validCards.join('');
        }

        // Update count
        const count = products.length;
        countEl.textContent = count === 1 
          ? `${count} produit dans votre liste d'envies`
          : `${count} produits dans votre liste d'envies`;

        // Show products section
        loadingEl.style.display = 'none';
        productsEl.style.display = 'block';

        // Initialize product card functionality
        initializeProductCards();
        WishlistManager.updateWishlistIcons();

      } catch (error) {
        console.error('Error loading wishlist products:', error);
        loadingEl.style.display = 'none';
        emptyEl.style.display = 'block';
      }
    }

    async function generateProductCard(product) {
      // Use Section Rendering API to fetch server-rendered product card
      // This ensures consistency with the product-card.liquid snippet
      const handle = product.handle;

      try {
        const response = await fetch(`/products/${handle}?section_id=wishlist-product-card`);
        if (response.ok) {
          return await response.text();
        }
      } catch (error) {
        console.error(`Error fetching product card for ${handle}:`, error);
      }

      return null;
    }

    function initializeProductCards() {
      // Add wishlist button functionality
      const wishlistButtons = document.querySelectorAll('.product-card__wishlist');
      wishlistButtons.forEach(button => {
        button.addEventListener('click', async function(e) {
          e.preventDefault();
          e.stopPropagation();
          
          const productCard = this.closest('[data-product-id]');
          const productId = parseInt(productCard.dataset.productId);
          
          if (productId) {
            try {
              const removed = await WishlistManager.remove(productId);
              if (removed) {
                // Remove from DOM with animation
                const productLink = productCard.closest('.product-card-link');
                if (productLink) {
                  productLink.style.transition = 'opacity 0.3s ease, transform 0.3s ease';
                  productLink.style.opacity = '0';
                  productLink.style.transform = 'scale(0.8)';
                  setTimeout(() => {
                    productLink.remove();
                    
                    // Check if wishlist is now empty
                    const remainingCards = document.querySelectorAll('.product-card-link');
                    if (remainingCards.length === 0) {
                      document.getElementById('collection-products').style.display = 'none';
                      document.getElementById('wishlist-empty').style.display = 'block';
                    } else {
                      // Update count
                      const countEl = document.getElementById('wishlist-count');
                      const newCount = remainingCards.length;
                      countEl.textContent = newCount === 1 
                        ? `${newCount} produit dans votre liste d'envies`
                        : `${newCount} produits dans votre liste d'envies`;
                    }
                  }, 300);
                }
              }
            } catch (error) {
              console.error('Error removing product from wishlist:', error);
            }
          }
        });
      });
    }
  });

  } catch(e) { console.error(e); }
})();
})();
